<template>
  <div>
    <px-view-header title="Mensagens Personalizadas" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-personalized-message-list-header :on-click-refresh="onClickRefresh"
                                         :on-change-filter="onChangeFilter"/>
    <px-personalized-message-list :messages="messages"
                                  :loading="loading"
                                  :on-change-options="onChangeOptions"
                                  :options-list="optionsList"
                                  @remove="onRemove"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import MessageService from './service/messages-service';
import PersonalizedMessageList from './listagem/MensagemPersonalizadaList.vue';
import PersonalizedMessageListHeader from './listagem/MensagemPersonalizadaListHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Mensagens Personalizadas' },
      ],
      messages: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'mensagem',
        sortDesc: false,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemMensagens', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getMessages();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getMessages();
    },
    onClickRefresh() {
      this.getMessages();
    },
    onRemove(item) {
      this.loading = true;
      MessageService.remover(item.id)
        .then(() => {
          this.$toast('Mensagem removida com sucesso', { color: 'success' });
          this.getMessages();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getMessages() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return MessageService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.messages = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
  components: {
    pxPersonalizedMessageList: PersonalizedMessageList,
    pxPersonalizedMessageListHeader: PersonalizedMessageListHeader,
  },
};

</script>
